/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Password_ShortInputs */

const cs_portal_password_short = /** @type {(inputs: Portal_Password_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo musí mít alespoň 8 znaků.`)
};

const en_portal_password_short = /** @type {(inputs: Portal_Password_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 8 characters.`)
};

/**
* | output |
* | --- |
* | "Password must be at least 8 characters." |
*
* @param {Portal_Password_ShortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_password_short = /** @type {((inputs?: Portal_Password_ShortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Password_ShortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_password_short(inputs)
	return cs_portal_password_short(inputs)
});